import { Component, OnInit } from '@angular/core';
import { TableData } from "../shared/components/data-table/data-table.component";
import { Report } from "../shared/models/report";
import { Appointment } from "../shared/models/appointment";
import { DataStoreService } from "../shared/services/api/data-store.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { Observable } from "rxjs";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public pendingAppointments: TableData<Appointment>;
  public reminders: Observable<Report[]> | Report[];

  private reminderData: Report[] = null;

  constructor(private dataStore: DataStoreService,
              private activatedRoute: ActivatedRoute,
              private notificationService: NotificationsService,
              public router: Router) {
  }

  ngOnInit() {

    this.pendingAppointments = this.dataStore.findAll(Appointment, {
      filter: { "type": "pending" }
    }).map(doc => doc.getModels());
    this.reminders = this.dataStore.findAll(Report, {
      filter: {
        type: "reminder",
        all: true
      }
    }).map(doc => doc.getModels())
      .do(data => {
        this.reminderData = data;
      });
  }

  private markAsDone(event, report: Report) {
    event.stopPropagation();
    report.reminder = null;
    report.save().subscribe(report => {
      this.notificationService.success("Abgeschlossen", "Bericht wurde als fertig markiert")
      this.reminderData = this.reminderData.filter(rep => rep.id != report.id);
      this.reminders = this.reminderData;
    })
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/dashboard/dashboard.component.ts